import { render, staticRenderFns } from "./composeInput.vue?vue&type=template&id=77e37eb0&scoped=true&"
import script from "./composeInput.vue?vue&type=script&lang=js&"
export * from "./composeInput.vue?vue&type=script&lang=js&"
import style0 from "./composeInput.vue?vue&type=style&index=0&id=77e37eb0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e37eb0",
  null
  
)

export default component.exports